import { DATETIME_FORMAT, MINUTES_STEP } from 'commons/js/constants'
import connectUrl from 'commons/js/components/connectUrl'
import { maybeParseMoment, makeMinuteTimeSpan, toTimestamp } from 'commons/js/util/dateConverter'
import { calculateStartDay, calculateEndDay, calculateNextQuarterFromNow, calculateToday } from 'commons/js/services/dateCalculator'
import ParkingContainer from './ParkingContainer'

const DEFAULT_DURATION_IN_MINUTES = 1 * 60
const DEFAULT_START_OFFSET_IN_MINUTES = 0
const MIN_TIME_SPAN_IN_MINUTES = 10

function parseBooleanParam (value) {
    return value === 'true'
}

function parseFilters (params) {
    const filters = {
        parkingType: {
            airport: parseBooleanParam(params['parking_type[airport]']),
            onlyMowizTruck: parseBooleanParam(params['parking_type[mowiztruck]']),
        },
        parkingProvider: {
            aena: parseBooleanParam(params['parking_provider[aena]']),
        },
        bookingService: {
            airportTransfer: parseBooleanParam(params['booking_service[airport_transfer]']),
            pickUp: parseBooleanParam(params['booking_service[pick_up]']),
            walking: parseBooleanParam(params['booking_service[walking]']),
        },
    }

    return filters
}

function mapParamsToProps (_, queryParams) {
    const duration = Math.max(0, parseInt(queryParams.duration)) || DEFAULT_DURATION_IN_MINUTES
    const startOffset = Math.max(0, parseInt(queryParams.start_date_offset)) || DEFAULT_START_OFFSET_IN_MINUTES
    const startDate = calculateStartDay(
        maybeParseMoment(queryParams.start_date, DATETIME_FORMAT, calculateNextQuarterFromNow()),
        calculateToday(MINUTES_STEP),
        makeMinuteTimeSpan(startOffset)
    )
    const endDate = calculateEndDay(
        startDate,
        maybeParseMoment(queryParams.end_date, DATETIME_FORMAT),
        makeMinuteTimeSpan(duration),
        makeMinuteTimeSpan(MIN_TIME_SPAN_IN_MINUTES)
    )
    const filters = parseFilters(queryParams)

    return {
        startDate: startDate && toTimestamp(startDate.format('YYYY-MM-DDTHH:mm')),
        endDate: endDate && toTimestamp(endDate.format('YYYY-MM-DDTHH:mm')),
        initialFilters: filters,
    }
}

export default connectUrl(mapParamsToProps)(ParkingContainer)
